import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';
import { SelectItemGroup, SelectItem, MessageService } from 'primeng';
import {  TreeNode } from 'primeng/api';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { error } from 'protractor';
import { rejects } from 'assert';
import { TopicCardService } from 'src/framework/services/topic-card.service';
import { TopicCardTypes } from '../add-new-topic-card/add-new-topic-card.component';
import { LogoIconMgmtService } from 'src/framework/services/logo-icon-mgmt.service';
import { ImageType } from 'src/app/enums/image-type';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';
import { environment } from 'src/environments/environment';
import { FolderManagementService } from 'src/framework/services/folder-mgmt.service';


@Component({
  selector: 'app-edit-topic-card',
  templateUrl: './edit-topic-card.component.html',
  styleUrls: ['./edit-topic-card.component.css']
})
export class EditTopicCardComponent implements OnInit {

  @Input() set docLanguageId(newLimit: number) {
    this.docLanguageIds(newLimit);
  }
  @Input() langDocList: any;
  @Input() canApproveOtherLang: boolean;
  @Input() isAllNonApproved: boolean;
  @Input() absoluteFilePath: string;
  @Output() outSaveVersion = new EventEmitter<any>();
  @ViewChild("ctrlFileUpload") ctrlFileUpload: ElementRef;
  @ViewChild('editor1') myEditor1: any;
  @ViewChild('editor2') myEditor2: any;

  isNewDraft = false;
  sourceDocToClone: any = {};
  emitVersionResponse: any = {
    isNewVersion: false,
    saveType: '',
    versionData: {}
  };
  docTypeList: any[];
  tempArray = [];
  menuindex=0;
  submenuIndex=0;
  menuItems = [];
  docTypeKeyValueList: SelectItem[];
  docCategoryKeyValueList: SelectItem[];
  pUpload: File;
  showDraftButton: boolean = false;
  showDraftPanel: boolean = false;
  showLeftPanel: boolean = false;
  leftPanelDoc: any = {};
  allowedFileTypes: string;
  approvedEngagementDocList: any[] = [];
  targetTreeData=[];
  isSortApplay = false;
  engagementDocList = [];
  secondaryTopicCards = [];
  showCategory = false;
  showIcons = false;
  showDate = true;
  selctedDocLanguageId = 1;
  icons: any[] = [];
  iconsselected: SelectItem[] = [];
  imageType = ImageType;
  selectedicons: any;
  showEditor = false;
  selectedType: TopicCardTypes;

  authorizerList: SelectItemGroup[] = [
    {
      label: 'Owners',
      items: []
    },
    {
      label: 'Reviewers',
      items: []
    },
    {
      label: 'PPAP',
      items: []
    },
    {
      label: 'Sr. Managers',
      items: []
    },
    {
      label: 'Admin',
      items: []
    }
  ];

  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    },
    {
      "languageId": 2,
      "languageName": "French",
      "languageFlagPath": "../../assets/flags/french.png"

    },
    {
      "languageId": 3,
      "languageName": "Spanish",
      "languageFlagPath": "../../assets/flags/spanish.png"

    }],

  }

  documentForm: FormGroup;
  environments=environment.ApplicationUrl+"/api/Document/download?docId=";
  formSubmitted: boolean;
  calendarYearRange: string;
  showDateMandatory: boolean;
  docDateDesc: any;
  languageName="EN";
  docInfo: string;
  draftDocValue: any;
  userDetail: any = {};
  showApproveButton: boolean = false;
  isApproverSelected: boolean = false;
  appLangList: any;
  errorMsg: string = '';
  tinyMceConfig: any;
  approverRemovedNote: string;
  rawApproverList: any[] = [];
  docCategoryList: any[] = [];
  selectedAppLanguage: any;
  selectedAppLanguageJson: any;
  defaultEnglishJson: any;

  selectedGlobalJson: any;
  defaultGlobalJson: any;


  selectedLangDocTypeJson: any;
  defaultEngDocTypeJson: any;
  islabelLoaded: boolean = false;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  localeSetting: any;

  constructor(private formBuilder: FormBuilder,
    private folderService: FolderManagementService,
    private manageTopicCardService: TopicCardService,
    private messageService: MessageService,
    private manageDocService: DocumentManagementService,
    private logoIconMgmtService: LogoIconMgmtService,
    private spinner: NgxSpinnerService,
    private languageService: LanguageService) {
    this.selectedType = new TopicCardTypes(1, '', '', new Date(), '', '');
    this.allowedFileTypes = ".doc,.docx,.dot,.jpg,.jpeg,.png,.tif,.pdf,.xls,.xlsx,.xlsb,.txt,.csv";
    this.calendarYearRange = (new Date().getUTCFullYear() - 10) + ':' + (new Date().getUTCFullYear() + 1);
  }

  ngOnInit(): void {
    this.loadLanguageLabel();
    this.approverRemovedNote = null;
    this.buildForm();
    if (sessionStorage.getItem('userDetail')) {
      this.userDetail = JSON.parse(sessionStorage.getItem('userDetail'));
    }
    this.initializeEngagementData().then((res) => {
      this.getEngagementApprovedDocument();
      this.setDocDateValidators();
      this.getTopicCardType();
      this.getTopicCardCategory();
      this.getEngagementDoc();
      this.getEngagementTopicCard();
      this.getLogoList();

    });

  }



  

  
  sortNode(node: TreeNode) {

    if (!('sortTypeId' in node?.data[0])) {
      node.data[0]['sortTypeId'] = '2';
    }

    if (node?.data[0]?.sortTypeId.toString() === '1') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children) {
        //node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children?.sort((a, b) => this.displayFolderLabel(a).localeCompare(this.displayFolderLabel(b)));


      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '2') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children) {
        //node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children?.sort((a, b) => this.displayFolderLabel(a).localeCompare(this.displayFolderLabel(b)));
        node?.children?.sort(this.folder_date_sort_desc);

      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '3') {

    }
    else if (node?.data[0]?.sortTypeId.toString() === '4') {

      //node?.children?.sort((a, b) => b.label?.localeCompare(a.label));
      node?.children?.sort((a, b) => this.displayFolderLabel(b).localeCompare(this.displayFolderLabel(a)));
      node?.children?.sort((a, b) => this.folder_date_sort_desc(a, b));

    }
  }

  
  folder_date_sort_desc = function (a, b) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    let res;
    if (a?.type?.toLowerCase() === 'file') {
      a = new Date(a?.data[0]?.documentDate).getTime() ?? new Date(a?.data[0]?.createdDTTM).getTime();
    }
    else {
      a = new Date(a?.data[0]?.createdDTTM).getTime();
    }

    if (b?.type?.toLowerCase() === 'file') {
      b = new Date(b?.data[0]?.documentDate).getTime() ?? new Date(b?.data[0]?.createdDTTM).getTime();
    }
    else {
      b = new Date(b?.data[0]?.createdDTTM).getTime();
    }

    res = a > b ? -1 : a < b ? 1 : 0;

    return res;

  }

  displayFolderLabel(node: TreeNode): string {
    let primaryLangId, otherPrimaryLangId = 0;
    let nodeLangList: any[] = [];
    let langIndex = -1;
    let folderLabel = '';
    if (node != null && node != undefined) {

      if (this.engagementDetail.appLanguage == 2) {
        primaryLangId = 2;
        otherPrimaryLangId = 1;
      }
      else //default is english
      {
        primaryLangId = 1;
        otherPrimaryLangId = 2;
      }

      folderLabel = node.label;
      nodeLangList = node?.data[0]?.language;



      if (nodeLangList?.length > 0) {
        if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(primaryLangId))) > -1) {
          if (nodeLangList[langIndex]?.folderName?.trim() !== ''
            && nodeLangList[langIndex]?.folderName !== null
            && nodeLangList[langIndex]?.folderName !== undefined) {
            folderLabel = nodeLangList[langIndex]?.folderName;
          }
          else {
            if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(otherPrimaryLangId))) > -1) {
              if (nodeLangList[langIndex]?.folderName?.trim() !== ''
                && nodeLangList[langIndex]?.folderName !== null
                && nodeLangList[langIndex]?.folderName !== undefined) {
                folderLabel = nodeLangList[langIndex]?.folderName;
              }
            }
          }
        }
      }
    }
    return folderLabel;

  }


  getFolderStructure() {
    this.spinner.show();
    this.folderService.getFolderTemplate(this.engagementDetail.engagementId).then(files => {
      if (files && files.length > 0) {
      
        var count: Array<number>=[];
        if (files.length > 0 && files[0].children) {
          let i =0;
          files[0].children.forEach(childNode => {
          if(childNode.label==undefined)
          {
            count.push(i);
          }
          i = i+1;
        });
        }
        
        count.forEach( val =>{
          files[0].children.pop(files[0].children[val]);
        });

        let x = this.removeEmptyFolder(files[0])
        x['label'] = "Public Documents"
        this.targetTreeData = x ? x.children.filter(t => t.styleClass != 'detailhideFileClass') : []
        if(!this.isSortApplay)
        {
         this.targetTreeData.forEach(x => {
           if (x.type.toLowerCase() === 'folder') {
             this.sortNode(x);
           }
         });
        }
        // this.targetTreeData = files.length > 0 ? files : []
        // this.preProcessTree();
      }
      this.configureTinyMce();
      this.showEditor = true;
      this.spinner.hide();
    });
  }

  preProcessTree(editor,environments,lanName) {


    this.tempArray=[];
    this.menuItems=[];
    this.targetTreeData.forEach(x => {
      this.preProcessTreeRecursive(x,editor,environments,lanName)
    });
    var newArray=[];

    var indexArray=Object.keys(this.menuItems);
    indexArray.forEach((item,index)=>{
      newArray[index]=this.menuItems[item];
    });
    return newArray;

}



preProcessTreeRecursive(node: any,editor,environments,lanName) {
  if (node != null && node != undefined) {
    if (node.type.toLowerCase() === 'file') {
      if(node.data[0]['parentId']==0){
        var docId = node.data[0].docId;
        this.menuItems.push(
          {
            type:'menuitem',
            text:node.label,
            id:node.key,
            
            onAction: function () {
              editor.insertContent("<a class='document' target='_blank' href="+environments+docId+"&language="+lanName+" >" + node.label + "</a>");        // editor.dom.add(editor.getBody(), 'div', {class: 'row'}, this.getColMd12(f));
            }
          }
        );
      }
        else{
          var nodes =this.findNode(node.data[0]['parentId']);
          var menuNodes = this.findMenuNode(node.data[0]['parentId']);
          var oldArrays=[];
          if(this.menuItems[node.data[0]['parentId']]){
            var docId = node.data[0].docId;
          oldArrays= this.menuItems[node.data[0]['parentId']].fetches;

          oldArrays.push({
            
            type:'menuitem',
            text:node.label,
            id:node.key,
            onAction: function () {
              editor.insertContent("<a class='document' target='_blank' href="+environments+docId+"&language="+lanName+" >" + node.label + "</a>");    
            }
          });

          this.menuItems[node.data[0]['parentId']].fetches=oldArrays;
          
          this.menuItems[node.data[0]['parentId']].getSubmenuItems=function(){return oldArrays;
          }
          }
          else{
            oldArrays= menuNodes.fetches;
          //   var prevArrays = this.menuItems[nodes['folderId']].fetches;
          //   var arrays = prevArrays.filter(item=>item.text===nodes.label);
          //  oldArrays = arrays[0].fetches;
          //  var parentIndex = prevArrays.indexOf(arrays[0]);
           var docId = node.data[0].docId;

           oldArrays.push({
            
            type:'menuitem',
            text:node.label,
            id:node.key,
            onAction: function () {
              editor.insertContent("<a class='document' target='_blank' href="+environments+docId+"&language="+lanName+" >" + node.label + "</a>");    
            }
          });

          menuNodes.fetches=oldArrays;
          menuNodes.getSubmenuItems=function(){return oldArrays;}
          
          }
          
         


        
        }
      }
    else if (node.type.toLowerCase() === 'folder') {
      if(node.children.length>0){

      if(node.hasOwnProperty('folderId')){
        var menuNodes = this.findMenuNode(node['folderId']);
        var menuArrays=[];
        var indexArrays=Object.keys(this.menuItems);
        indexArrays.forEach((item,index)=>{
          menuArrays[index]={...this.menuItems[item]};
        });
        //var trees= this.filterData(menuArrays,node['folderId']);
        var oldfolderArrays= menuNodes.fetches;

        oldfolderArrays.push({
          
          type:'nestedmenuitem',
          text:node.label,
          id:node.key,
          fetches:[],
          getSubmenuItems: function () {
          }
        });

        menuNodes.getSubmenuItems=function(){return oldfolderArrays;}

        // if(this.menuItems[node['folderId']]){
        
        // this.menuItems[node['folderId']].fetches=oldfolderArrays;
        
        // this.menuItems[node['folderId']].getSubmenuItems=function(){return oldfolderArrays;
        // }
        // }
        // else if(this.menuItems[trees[0].id]){
        //  var newItems= this.menuItems[trees[0].id].fetches.filter(item=>item.id===node['folderId'])
        //  if(newItems.length>0){
        //  newItems[0].fetches = oldfolderArrays;
        //  newItems[0].getSubmenuItems=function(){return oldfolderArrays;}
        //  }
        //  else if(this.menuItems[trees[0].id])
        // }

      }
      else{
        this.menuItems[node.key]={
          type:'nestedmenuitem',
          text: node.label,
          id:node.key,
          fetches:[],
          folderfetches:[],
          getSubmenuItems: function(){

          }
        };
      }
    }

    }
    if (node.children) {
      node.children.forEach(childNode => {
        this.preProcessTreeRecursive(childNode,editor,environments,lanName);
      });
    }
  }
}



findNode(nodeKey): TreeNode {
  var found = false;
  let foundNode: TreeNode = {};

  function recurseFindParent(searchTree) {

    for (var i = 0; i < searchTree.length; i++) {

      // Found the category!
      if (Number(searchTree[i].key) === Number(nodeKey)) {
        foundNode = searchTree[i];
        found = true;
        break;

        // Did not match...
      } else {
        // Are there children / sub-categories? YES
        // if(searchTree[i].children !== ''){
        if (searchTree[i].children.length > 0) {
          recurseFindParent(searchTree[i].children);
          if (found) {
            break;
          }
        }
        //}
      }
    }
  }

  recurseFindParent(this.targetTreeData);

  return foundNode;
}


filterData(data:any, id) {
 var that=this;
  var r = data.filter(function(o) {
    if (o.fetches.length>0) 
    {
      o.fetches = that.filterData(o.fetches, id);
    }
    return o.id != id
  })
  return r;
}



findMenuNode(nodeKey): any {
  var found = false;
  let foundNode: any = {};

  function recurseFindParent(searchTree) {
    

    for (var i = 0; i < searchTree.length; i++) {
      if(searchTree[i]){

      // Found the category!
      if (Number(searchTree[i].id) === Number(nodeKey)) {
        foundNode = searchTree[i];
        found = true;
        break;

        // Did not match...
      } else {
        // Are there children / sub-categories? YES
        // if(searchTree[i].children !== ''){
        if (searchTree[i].fetches&&searchTree[i].fetches.length > 0) {
          recurseFindParent(searchTree[i].fetches);
          if (found) {
            break;
          }
        }
        //}
      }
    }
    }
  }

  recurseFindParent(this.menuItems);

  return foundNode;
}



  

  removeEmptyFolder(node: any) {

    let primaryLangId, otherPrimaryLangId, secondPrimaryLangId, thirdPrimaryLangId, fourthPrimaryLangId, fifthPrimaryLangId = 0;

    if (this.engagementDetail.appLanguage == 2) {
      primaryLangId = 2;
      otherPrimaryLangId = 1;
    }
    else if (this.engagementDetail.appLanguage == 1) {
      primaryLangId = 1;
      otherPrimaryLangId = 2;
    }
    else if (this.engagementDetail.appLanguage == 3) {
      primaryLangId = 3;
      otherPrimaryLangId = 1;
      secondPrimaryLangId = 2;
    }

    else //default is english
    {
      primaryLangId = 1;
      otherPrimaryLangId = 2;
    }
    let isValidFolder = false;
    for (let i = 0; i < node.children.length; i++) {
      if (node.children[i].type == 'folder') {
        if(node.type=='folder'){
          node.children[i]['folderId']=node.key;
          }
        this.sortNode(node);
        if (this.removeEmptyFolder(node.children[i]).styleClass != 'detailhideFileClass') {
          isValidFolder = true;
        }
      } else if (node.children[i].type == 'file') {
        if (this.approvedEngagementDocList && this.approvedEngagementDocList.length > 0) {
          let res = this.approvedEngagementDocList.find(x => x.docId == node.children[i].data[0].docId && x.docVersionId == node.children[i].data[0].docVersionId && primaryLangId == node.children[i].data[0].languageId)
          if (res == null || res == undefined)
            res = this.approvedEngagementDocList.find(x => x.docId == node.children[i].data[0].docId && x.docVersionId == node.children[i].data[0].docVersionId && otherPrimaryLangId == node.children[i].data[0].languageId)
          if (res == null || res == undefined)
            res = this.approvedEngagementDocList.find(x => x.docId == node.children[i].data[0].docId && x.docVersionId == node.children[i].data[0].docVersionId && secondPrimaryLangId == node.children[i].data[0].languageId)
          if (res) {
            node.children[i].styleClass = 'fileClass';
            node.children[i]['description'] = res.documentDescription;
            node.children[i]['docId'] = res.docId
            node.children[i]['documentDate'] = res.documentDate
            isValidFolder = true;
          } else {
            node.children[i].styleClass = 'detailhideFileClass';

          }
        }
      }
    }
    if (node.type == "folder" && !isValidFolder) {
      node.styleClass = 'detailhideFileClass';
    }
    return node;
  }
  
    



  docLanguageIds(limit: number) {
    this.selctedDocLanguageId = limit;
    if(this.selctedDocLanguageId==1){
        this.languageName="EN";
    }
    else{
      this.languageName="FR";
    }
  }


  configureTinyMce() {
    const that = this;
    this.tinyMceConfig = {
      branding: false,
      toolbar_mode: 'sliding',
      toolbar_sticky: false,
      inline: false,
      statusbar: false,
      theme: "silver",
      resize: false,
      skin: "oxide",
      skin_url: 'assets/skins/ui/oxide',
      base_url: '/tinymce',  
      suffix: '.min',
      plugins: [
        "print preview   importcss autoresize searchreplace autolink autosave save directionality  visualblocks visualchars fullscreen image link media  template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists  wordcount   imagetools textpattern noneditable help code charmap  emoticons "],
      menubar: 'edit insert view  format table tools help',
      // content_css: [
      //   '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
      // ],

      paste_as_text: true,
      paste_text_sticky: true,
      font_formats: 'EYFontRegular=EYFontRegular;',
      theme_advanced_fonts: "EYFontRegular=EYFontRegular",
      force_br_newlines: false,
      //force_p_newlines: false,
      allow_script_urls: true,
      relative_urls : false,
      remove_script_host : false,
      entity_encoding : "raw",
      document_base_url : that.environments,
      //forced_root_block: '',
      extended_valid_elements: "@[id|class|title|style|onmouseover|onclick]," +
        "a[name|href=javascript:void(0);|target|title|alt]," +
        "#div,blockquote,-ol,-ul,-li,br,img[src|height|width],-sub,-sup,-b,-i,-u," +
        "-span[data-mce-type],hr,",
      toolbar: 'document topicCard | bold italic backcolor | ' +
        'bullist numlist outdent indent | alignright alignjustify |' +
        '   alignleft aligncenter | removeformat |' +
        ' help ',
      setup: function (editor) {
        const test = that.engagementDocList.map(f => {
          return {
            type: 'menuitem',
            text: f.label,
            onAction: function () {
              editor.insertContent("<a class='document' target='_blank' href="+that.environments+f.value+"&language="+that.languageName+" >" + f.label + "</a>");        // editor.dom.add(editor.getBody(), 'div', {class: 'row'}, this.getColMd12(f));
            }
          };
        });

        const topictest = that.secondaryTopicCards.map(f => {
          return {
            type: 'menuitem',
            text: f.label,
            onAction: function () {
              editor.insertContent("<a class='topicCard'  href='javascript:void(0);' onclick='Window.myComponent.openTopics(" + f.value + ")'>" + f.label + "</a>");        // editor.dom.add(editor.getBody(), 'div', {class: 'row'}, this.getColMd12(f));
              //editor.setContent('<a (click)="openTopicCard('+f.value+')"><p>'+f.label+'</p></a>');
            }
          };
        });
        /* example, adding a toolbar menu button */
        editor.ui.registry.addMenuButton('document', {
          text: 'Document',
          fetch: function (callback) { 
            callback(that.preProcessTree(editor,that.environments,that.languageName));
          }
        });

        editor.ui.registry.addMenuButton('topicCard', {
          text: 'Topic Cards',
          fetch: function (callback) {
            callback(topictest);
          }
        });
      }
    };
  }

  initializeEngagementData() {

    let minYear;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('appLanguageList')) {
        this.appLangList = JSON.parse(sessionStorage.getItem('appLanguageList'));
      }

      if (sessionStorage.getItem('engagementDetail')) {
        this.engagementDetail = JSON.parse(sessionStorage.getItem('engagementDetail'));
        minYear =
          Number(new Date().getUTCFullYear() - 10) <
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear()) ?
            Number(new Date().getUTCFullYear() - 10) :
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear());

        this.calendarYearRange = minYear + ':' + (new Date().getUTCFullYear() + 1);
      }
      resolve(1);
    });
  }



  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishGlobalMappings, selectedGlobalMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedAppLanguage = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedAppLanguage = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishGlobalMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedGlobalMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
          }
          else {
            if (Number(this.selectedAppLanguage) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];


              selectedGlobalMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedGlobalMappings = englishGlobalMappings;
              selectedLangDateMappings = englishDateMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings?.languageMappingJSON ?? englishLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);


          this.selectedGlobalJson = JSON.parse(selectedGlobalMappings?.languageMappingJSON ?? englishGlobalMappings.languageMappingJSON);
          this.defaultGlobalJson = JSON.parse(englishGlobalMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.docDateDesc = this.labelReplacer('txtDocDate');
          this.setCalendarLocale();

          this.docDateDesc = this.labelReplacer('TopicCardDate');
          this.islabelLoaded = true;
          resolve(1);
        }
        else {
        }
      });
    })
      .catch(err => {

        console.log(err);
      });
  }


  labelReplacer(labelKey): string {
    let value;
    value = this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
    return value;
  }

  CategoryReplacer(labelKey): string {
    let value;
    value = this.selectedGlobalJson[labelKey]?.trim() ? this.selectedGlobalJson[labelKey] ?? 'text not found' : this.defaultGlobalJson[labelKey] ?? 'text not found';
    return value;
  }

  monthReplacer(labelKey): string {
    let localeDt;
    if (labelKey) {
      let arr = labelKey.split(' ');
      if (arr?.length == 3)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2];
      else
        localeDt = labelKey;
    }
    return localeDt;
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
        ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }

  buildForm() {
    this.documentForm = this.formBuilder.group({
      docStatus: [''],
      docTitle: ['', Validators.required],
      docDescription: ['',Validators.required],
      docType: ['', Validators.required],
      docDate: [''],
      docCategory: [''],
      docIcon: [''],
      approvalRequestedFrom: ['']
    });

  }


  getLogoList() {
    console.log('secomdary', this.secondaryTopicCards);
    this.iconsselected = [];
    this.logoIconMgmtService.getLogoIconList().subscribe((response) => {
      if (response && response.data?.length > 0) {


        var iconList = response.data.filter(item => item.imageTypeId === this.imageType.Icon);
        if (iconList.length > 0) {
          iconList.forEach(item => {
            item.url = 'data:image/png;base64,' + item.result;
          })
        }
        iconList.forEach(item => {
          this.iconsselected.push(
            {
              'label': item.imageLink,
              'value': item.logoIconImageDataId,
              'icon': item.url
            }
          )
        });
        var newIcons=this.documentForm.get('docIcon').value;
        if(newIcons!=""){
        }
      }
      this.icons = iconList
    });
  }


  getTopicCardType() {
    this.manageTopicCardService.getTopicCardType().subscribe(res => {
      if (res) {
        this.docTypeKeyValueList = res.data.map(x => ({
          label: this.CategoryReplacer(x.topicCardTypeDescription),
          value: x.topicCardTypeId
        }));
        //success
        this.docTypeList = res.data;
        console.log(res);
      } else {
        //display error
      }
      this.getApproverList(+this.engagementDetail.engagementId);
    });
  }

  getApproverList(engagementId) {
    this.manageDocService.getApproverList(engagementId).subscribe(res => {
      if (res.status === 0) {
        //success
        this.rawApproverList = res.data;
        this.formatApproverList()
          .then(res => this.initializeFormControls())
          .catch(error => console.log(error));
      } else {
        //display error
        this.initializeFormControls();
      }
    });
  }

  formatApproverList() {
    return new Promise((resolve, reject) => {
      let ownerList, reviewerList, partnerList, srMangerList, adminList: any[] = [];
      this.authorizerList = [];

      this.authorizerList.push({
        label: this.labelReplacer('lblOwner'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblReviewer'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblPPAP'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblSrManager'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblAdmin'),
        items: []
      });

      if (this.rawApproverList.length > 0) {
        ownerList = this.rawApproverList[0];
        reviewerList = this.rawApproverList[1];
        partnerList = this.rawApproverList[2];
        srMangerList = this.rawApproverList[3];
        adminList = this.rawApproverList[4];

        this.setDesignationList(ownerList, 0);
        this.setDesignationList(reviewerList, 1);
        this.setDesignationList(partnerList, 2);
        this.setDesignationList(srMangerList, 3);
        this.setDesignationList(adminList, 4);

      }

      resolve(1);
    })
      .catch(error => {
        console.log(error);
      })
  }

  setDesignationList(userList, index) {
    if (userList.length > 0) {
      this.authorizerList[index].items = userList.map(x => ({
        label: x.emailId,
        value: x.emailId
      }));
    }
  }



  getStatusPillClass(statusId) {

    let pillClass = '';
    if (statusId) {
      if (statusId === 2 || statusId === 4 || statusId === 7)
        pillClass = 'pill pill--approved m-0';
      else if (statusId === 1)
        pillClass = 'pill pill--closed m-0';
      else if (statusId === 3 || statusId === 6)
        pillClass = 'pill pill--failed m-0';
    }

    return pillClass;
  }

  initializeFormControls() {

    this.draftDocValue = {};
    this.showLeftPanel = false;
    this.showDraftPanel = false;

    if (this.langDocList) {
      this.showDraftButton = this.langDocList['showDraftButton'];
      if (this.showDraftButton) {
        //keep right panel hidden
        this.isNewDraft = true;
        this.showLeftPanel = this.showDraftButton;
        this.showDraftPanel = !this.showDraftButton;
        //bind left panel with data
        this.leftPanelDoc = this.langDocList['languageDocList'][0];
      }
      else //if show draft button = false
      {
        //show draft panel
        this.draftDocValue['sourceVersionId'] = 0;
        this.showDraftPanel = !this.showDraftButton;

        //show both existing approved/unapproved and draft
        if (this.langDocList['languageDocList']?.length > 1) {
          this.showLeftPanel = true;
          this.isNewDraft = false;
          //show approved/unapproved document
          this.leftPanelDoc = this.langDocList['languageDocList'][0];
          //show draft document
          this.draftDocValue = this.langDocList['languageDocList'][1];
          this.setDraftDocValue();
        }
        else if (this.langDocList['languageDocList']?.length > 0) {
          //show existing/new draft document
          this.draftDocValue = this.langDocList['languageDocList'][0];
          this.isNewDraft = this.draftDocValue.docVersionId === 0 ? true : false;
          this.setDraftDocValue();
        }
        else {
          this.isNewDraft = true;
        }

        //prepopulate doc type based validation and details
        this.getDocTypeDetails(this.draftDocValue['documentTypeId']);

      }

    }

  }

  setDraftDocValue() {
    if (this.draftDocValue['topicCardTypeId'] == 1) {
      this.showCategory = true;
      this.showIcons = true;
      this.showDate = false;
    }

    this.selectedType.topicCardTypeId = this.draftDocValue['topicCardTypeId'];
    this.documentForm.patchValue({
      docStatus: this.draftDocValue['statusName'],
      docTitle: this.draftDocValue['tctitle'],
      docDescription: this.draftDocValue['description'],
      docType: this.draftDocValue['topicCardTypeId'],
      docCategory: this.draftDocValue['topicCardCategoryId'],
      docIcon: this.draftDocValue['iconRef'],
      docDate: this.draftDocValue['topicCardDate'] === null ? null : new Date(this.draftDocValue['topicCardDate']),
      approvalRequestedFrom: this.draftDocValue['approvalRequestedFromGpn']
    });

    this.approverCheck(this.draftDocValue['approvalRequestedFromGpn']);
  }

  setDocDateValidators() {

    this.documentForm.get('docType').valueChanges
      .subscribe(selectedDocType => {
        this.getDocTypeDetails(selectedDocType);
      });

  }

  getDocTypeDetails(docTypeValue) {
    let docTypeData = this.docTypeList.filter(x => x.topicCardTypeId === docTypeValue)[0];
    if (docTypeValue) {
      if (docTypeValue === 1) {
        this.showCategory = true;
        this.showIcons = true;
        this.showDate = false;
      }
      else if (docTypeValue === 2) {
        const docDateControl = this.documentForm.get('docDate');
        docDateControl.setValidators(null);
        this.showDateMandatory = false;
        this.docDateDesc = docTypeData?.descriptionOfDate;
      }




    }

  }

  saveDocumentVersion(saveType: string): Promise<boolean> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      let fileToUpload: any;
      let fileCopy = false;
      this.emitVersionResponse = {};

      this.formSubmitted = true;
      // stop here if form is invalid
      if (this.documentForm.invalid) {
        this.spinner.hide();
        return;
      }
      else {


        let documentData = {
          ...this.documentForm.value,
          'engagementId': this.engagementDetail.engagementId,
          'languageId': this.draftDocValue?.languageId,
          'topicCardId': this.draftDocValue?.topicCardId,
          'tcversionId': this.isNewDraft ? 0 : this.draftDocValue.tcversionId,
          'statusId': 1,
          'documentDate': (this.documentForm.controls['docDate']?.value == null || 
          this.documentForm.controls['docDate']?.value == undefined || 
          this.documentForm.controls['docDate']?.value == '')  ?  null : new Date(this.documentForm.controls['docDate'].value).toDateString(),
        }

        this.emitVersionResponse.isNewVersion = this.isNewDraft;

        formData.append('fileJson', JSON.stringify(documentData));

        this.manageTopicCardService.saveTopicCardVersion(formData).subscribe(res => {
          if (res?.status === 0) {
            //success
            this.emitVersionResponse.versionData = res.data;
            this.emitVersionResponse.saveType = saveType;

            if (saveType.toLowerCase() === 'save') {
              this.outSaveVersion.emit(this.emitVersionResponse);
            }
            this.spinner.hide();
            resolve(true);
          } else {
            //display error
            if (res?.status === 2) {

              if (res?.data?.toLowerCase() === 'pendingdraftsaveerror') {
                this.errorMsg = this.labelReplacer('UnabletosaveTopicCardasitisnolongeradraft');
                this.emitVersionResponse.saveType = 'draftApproved';
              }
              else if (res?.data?.toLowerCase() === 'versionnotfound') {
                this.emitVersionResponse.saveType = 'draftDeleted';
                this.errorMsg = this.labelReplacer('UnabletosaveTopicCardasitnolongerexists');
              }
              else {
                this.errorMsg = res?.data ?? '';
              }

              this.messageService.add({
                summary: this.labelReplacer('Error:Unabletosavedocumentversion'),
                detail: this.errorMsg,
                sticky: false,
                severity: 'error'
              });
              this.spinner.hide();
              this.outSaveVersion.emit(this.emitVersionResponse);

            }
            else {
              this.errorMsg = res.data;

              this.messageService.add({
                summary: this.labelReplacer('Error:UnabletosaveTopicCardversion'),
                detail: this.errorMsg,
                sticky: false,
                severity: 'error'
              });
              this.spinner.hide();

            }
            reject(false);
          }
        });

      }
    });

  }


  getEngagementDoc() {
    return new Promise((resolve, reject) => {
      this.manageDocService.getEngagementDocument(this.engagementDetail).subscribe(res => {
        if (res) {
          //success
          if (res.data && res.data.length > 0 && this.engagementDocList.length == 0) {
            res.data.forEach(item => {
              item.documentVersionList.forEach(element => {
                if (element.languageId == this.selctedDocLanguageId && element.currentAuthorized==true) {
                  this.engagementDocList.push({ 'label': element.documentTitle, 'value': element.docId });
                }
              });
            });
          }
          else {
            this.engagementDocList = [];
          }
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }


  getEngagementApprovedDocument() {
    this.engagementDetail['statusName']=this.engagementDetail.engStatusName;
    this.manageDocService.getEngagementApprovedDocument(this.engagementDetail).subscribe(res => {
      if (res) {
        //success
        this.approvedEngagementDocList = res.data;
        this.getFolderStructure();
      } else {
        //display error
      }
  });
}


  getEngagementTopicCard() {
    return new Promise((resolve, reject) => {
      this.manageTopicCardService.getEngagementTopicCard(this.engagementDetail).subscribe(res => {
        if (res) {
          this.secondaryTopicCards = [];
          //success
          var topicCards = res.data;
          topicCards.forEach(item => {
            if (item.topicCardTypeId == 1) {
              if (item.topicCardCategoryId == 2) {

                item.topicCardVersionList.forEach(element => {
                  if (element.languageId == this.selctedDocLanguageId&& element.currentAuthorized==true) {
                    this.secondaryTopicCards.push({ 'label': element.tctitle, 'value': element.topicCardId });
                  }
                });

              }


            }
          });
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  onUpload(event) {
    for (let file of event.files) {
      this.pUpload = file;
      this.documentForm.patchValue({
        documentLink: this.pUpload.name
      });
      //this.draftDocValue.documentLink = this.pUpload.name;
    }
  }

  cloneDraft(cloneDoc) {
    this.showDraftButton = false;
    this.isNewDraft = true;
    this.draftDocValue = _.cloneDeep(cloneDoc);
    this.draftDocValue['sourceVersionId'] = cloneDoc.tcversionId;
    this.draftDocValue['tcversionId'] = 0;
    if (cloneDoc['topicCardTypeId'] == 1) {
      this.documentForm.patchValue({
        docStatus: cloneDoc['statusName'],
        docTitle: cloneDoc['tctitle'],
        docDescription: cloneDoc['description'],
        docType: cloneDoc['topicCardTypeId'],
        docCategory: cloneDoc['topicCardCategoryId'],
        docDate: new Date(cloneDoc['topicCardDate']),
        docIcon: cloneDoc['iconRef']
        //approvalRequestedFrom: cloneDoc['approvalRequestedFromGpn']
      });
    } else if (cloneDoc['topicCardTypeId'] == 2) {
      this.documentForm.patchValue({
        docStatus: cloneDoc['statusName'],
        docTitle: cloneDoc['tctitle'],
        docDescription: cloneDoc['description'],
        docType: cloneDoc['topicCardTypeId'],
        docDate: new Date(cloneDoc['topicCardDate']),
        docIcon: cloneDoc['iconRef']
        //approvalRequestedFrom: cloneDoc['approvalRequestedFromGpn']
      });
    }

    //prepopulate doc type based validation and details
    this.getDocTypeDetails(cloneDoc['topicCardTypeId']);
    this.showDraftPanel = true;
  }



  resetForm() {
    this.formSubmitted = false;
    this.documentForm.controls['docTitle'].setValue('');
    this.documentForm.controls['docDescription'].setValue('');
    this.documentForm.controls['documentHash'].setValue('');
    this.documentForm.controls['documentLink'].setValue('');
    this.documentForm.controls['docType'].setValue('');
    this.documentForm.controls['docCategory'].setValue('');
    this.documentForm.controls['docIcon'].setValue('');
    this.documentForm.controls['docDate'].setValue('');
    this.documentForm.controls['approvalRequestedFrom'].setValue('');
    this.pUpload = null;
    this.docInfo = '';
    this.docDateDesc = 'Document Date';
    this.ctrlFileUpload['files'] = [];
    this.isNewDraft = false;
    this.sourceDocToClone = {};
  }

  approverChange(event) {
    this.approverCheck(event?.value);
  }

  approverCheck(selectedApprover) {
    this.approverRemovedNote = null;
    if (selectedApprover) {
      //check if user exists in approver list
      if (this.findAuthorizer(selectedApprover)) {
        this.isApproverSelected = true;
        if (selectedApprover?.toString().toLowerCase() === this.userDetail?.emailId?.toLowerCase()) {
          this.showApproveButton = true;
        }
        else {
          this.showApproveButton = false;
        }
      }
      else {
        this.isApproverSelected = false;
        this.showApproveButton = false;
        this.approverRemovedNote = 'The previously selected approver no longer exists.Please select a new approver.'
      }
    }
    else {
      this.isApproverSelected = false;
    }

  }


  findAuthorizer(selectedApprover): any {
    let authIndex = -1;
    let searchObj = null;
    this.authorizerList.forEach(x => {
      if ((authIndex = x.items.findIndex(y => y.label?.toLowerCase() ?? '' === selectedApprover.toLowerCase())) > -1) {
        searchObj = {} = x.items[authIndex];
      }
    });

    return searchObj;
  }

  approveDocumentVersion(approvalType: string) {

    this.spinner.show();
    if (this.canApprovalBeSent()) {
      //approval type = others ->save version / send email / mark version as pending approval
      this.emitVersionResponse.saveType = approvalType;
      if (approvalType.toLowerCase() === 'other') {
        this.saveDocumentVersion('approve')
          .then((res) =>
            this.sendApprovalMail()
              .then((res) => {
                this.emitVersionResponse.saveType = approvalType;
                this.outSaveVersion.emit(this.emitVersionResponse);
              })
              .catch((error) => {
                console.log(error);
                this.spinner.hide();
              }))
          .catch((error) => {
            console.log(error)
            this.spinner.hide();
          });
      }
      else if (approvalType.toLowerCase() === 'self') {
        //if approval type = self -> approve version
        this.saveDocumentVersion('approve')
          .then((res) =>
            this.approve()
              .then((res) => {
                this.emitVersionResponse.saveType = approvalType;
                this.outSaveVersion.emit(this.emitVersionResponse);
              })
              .catch((error) => {
                console.log(error);
                this.spinner.hide();
              }))
          .catch((error) => {
            console.log(error)
            this.spinner.hide();
          });

      }

    }
    else {
      if (this.draftDocValue?.languageId === 1 || this.draftDocValue?.languageId === 2) {
        this.messageService.add({
          summary: this.labelReplacer('Error:Unabletorequestforapproval'),
          detail: this.labelReplacer('Pleaseattachafile'),
          sticky: false,
          severity: 'error'
        });
      }
      else {
        this.messageService.add({
          summary: this.labelReplacer('Error:Unabletorequestforapproval'),
          detail: this.labelReplacer('Pleaseensureeitherenglishorfrenchversionisapproved'),
          sticky: false,
          severity: 'error'
        });
      }

      this.spinner.hide();

    }


  }

  canApprovalBeSent(): boolean {
    let isAllowed = false;

    if (this.canApproveOtherLang) {
      isAllowed = true;
    }
    else {
      if (this.draftDocValue?.languageId === 1 || this.draftDocValue?.languageId === 2) {
        isAllowed = true;
      }
      else {
        isAllowed = false;
      }

    }
    return isAllowed;

  }

  checkForAttachmentInDraft(): boolean {
    let isFileExists = false;
    if (this.isNewDraft) {
      if (this.documentForm.controls['documentLink']?.value !== null
        && this.documentForm.controls['documentLink']?.value !== undefined) {
        isFileExists = true;
      }
      else {
        isFileExists = false;
      }
    }
    else {
      if (this.draftDocValue.documentLink !== null
        && this.draftDocValue.documentLink !== undefined) {
        isFileExists = true;
      }
      else {
        isFileExists = false;
      }
    }

    return isFileExists;
  }

  approve() {
    this.spinner.show();
    let approveVersion = {};
    approveVersion = this.emitVersionResponse?.versionData;
    return new Promise((resolve, reject) => {
      this.manageTopicCardService.approveDocumentVersion(approveVersion).subscribe(res => {
        if (res.status === 0) {
          //success
          resolve(true);
        }
        else {
          //display error
          reject(false);
        }

      });
    });
  }


  getTopicCardCategory() {
    this.manageTopicCardService.getTopicCardCategory().subscribe(res => {
      if (res) {
        //success
        this.docCategoryKeyValueList = res.data.map(x => ({
          label: this.CategoryReplacer(x.topicCardCategoryDescription),
          value: x.topicCardCategoryId
        }));
        this.docCategoryList = res.data;
        console.log(res);
      } else {
        //display error
      }

    });
  }

  sendApprovalMail() {
    this.spinner.show();
    let approveVersion = {};
    approveVersion = this.emitVersionResponse?.versionData;
    approveVersion['authorizerEmail'] = this.findAuthorizer(approveVersion['approvalRequestedFromGpn']);
    approveVersion['absoluteFilePath'] = this.absoluteFilePath;
    return new Promise((resolve, reject) => {
      this.manageTopicCardService.sendTopicCardApprovalMail(approveVersion).subscribe(res => {
        if (res?.data) {
          //success
          resolve(true);
        }
        else {
          //display error
          reject(false);
        }
      });
    });
  }

  onFileRemove(event) {
    this.pUpload = null;
    this.documentForm.patchValue({
      documentLink: this.draftDocValue.documentLink
    });
  }


}

